import React, { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import axios from 'axios';
import Navbar from "../components/Navbar";
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

const PublicForm = ({ onClose }) => {
  const [formData, setFormData] = useState(() => {
    const savedFormData = localStorage.getItem('formData');
    return savedFormData ? JSON.parse(savedFormData) : {
      name: "",
      fatherName: "",
      address: "",
      district: "",
      phone1: "",
      phone2: "",
      phone3: "",
      phone4: "",
    };
  });

  const apiUrl = 'https://api.infosware-test.in';

  const [qrData, setQrData] = useState(null);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false); // State for checkbox

  useEffect(() => {
    localStorage.setItem('formData', JSON.stringify(formData));
  }, [formData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newErrors = { ...errors };

    // Prevent spaces at the start
    if (value.startsWith(" ")) {
      newErrors[name] = "Field cannot start with a space";
    } else if ((name === "name" || name === "fatherName" || name === "district") && /\d/.test(value)) {
      // Prevent numbers in the name, father's name, and district fields
      newErrors[name] = `${name.replace(/([A-Z])/g, ' $1')} cannot contain numbers`;
    } else if (name.startsWith("phone")) {
      // Ensure phone numbers contain exactly 10 digits and no characters
      if (!/^\d*$/.test(value)) {
        newErrors[name] = "Phone number cannot contain characters";
      } else if (value.length > 10) {
        newErrors[name] = "Phone number must be exactly 10 digits";
      } else {
        delete newErrors[name];
      }
    } else {
      delete newErrors[name];
    }

    setErrors(newErrors);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!agreed) {
      alert("You must agree to the terms and conditions before submitting the form.");
      return;
    }

    let hasError = false;
    let newErrors = {};

    for (let key in formData) {
      if (formData[key].startsWith(" ")) {
        newErrors[key] = "Field cannot start with a space";
        hasError = true;
      }
      if ((key === "name" || key === "fatherName" || key === "district") && /\d/.test(formData[key])) {
        newErrors[key] = `${key.replace(/([A-Z])/g, ' $1')} cannot contain numbers`;
        hasError = true;
      }
      if (key.startsWith("phone")) {
        if (!/^\d*$/.test(formData[key])) {
          newErrors[key] = "Phone number cannot contain characters";
          hasError = true;
        }
        if (formData[key].length !== 10 && formData[key].length !== 0) {
          newErrors[key] = "Phone number must be exactly 10 digits";
          hasError = true;
        }
      }
    }

    if (formData.phone1.length !== 10) {
      newErrors.phone1 = "Phone number 1 must be exactly 10 digits";
      hasError = true;
    }

    setErrors(newErrors);
    if (hasError) return;

    const formattedData = `
      Name: ${formData.name}
      ${formData.phone1 ? `Phone 1: ${formData.phone1}` : ""}
      ${formData.phone2 ? `Phone 2: ${formData.phone2}` : ""}
      ${formData.phone3 ? `Phone 3: ${formData.phone3}` : ""}
      ${formData.phone4 ? `Phone 4: ${formData.phone4}` : ""}
    `;
    setQrData(formattedData);

    try {
      await axios.post(`${apiUrl}/api/registration`, {
        ...formData,
        qr_data: JSON.stringify({
          name: formData.name,
          fatherName: formData.fatherName,
          address: formData.address,
          district: formData.district,
          phone1: formData.phone1,
          phone2: formData.phone2,
          phone3: formData.phone3,
          phone4: formData.phone4,
        }),
      });
      localStorage.removeItem('formData');
      setFormData({
        name: "",
        fatherName: "",
        address: "",
        district: "",
        phone1: "",
        phone2: "",
        phone3: "",
        phone4: "",
      });
      setAgreed(false); // Reset checkbox
      setFormSubmitted(true);
      alert("Form submitted successfully!");
    } catch (error) {
      console.error('Error submitting form data', error.response ? error.response.data : error.message);
    }
  };

  const downloadQR = () => {
    const canvas = document.getElementById("qrCode");
    const context = canvas.getContext("2d");

    // Add padding
    const padding = 20;
    const newCanvas = document.createElement("canvas");
    newCanvas.width = canvas.width + padding * 2;
    newCanvas.height = canvas.height + padding * 2;
    const newContext = newCanvas.getContext("2d");

    // Set background color
    newContext.fillStyle = "#ffffff";
    newContext.fillRect(0, 0, newCanvas.width, newCanvas.height);

    // Draw the original canvas onto the new canvas with padding
    newContext.drawImage(canvas, padding, padding);

    const pngUrl = newCanvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qr_code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    setFormSubmitted(false);
    setQrData(null);
  };

  return (
    <div>
      <Navbar />
      <div style={{ width: "100%", minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div className="card is-shadowless" style={{ width: "80%" }}>
          <div className="card-content">
            <div className="content">
              {!formSubmitted && (
                <div style={{ marginTop: "40px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <h1 className="title">New Registrations</h1>
                  {/* <FaTimes onClick={onClose} style={{ cursor: "pointer" }} /> */}
                </div>
              )}
              {formSubmitted ? (
                <div style={{ textAlign: "center" }}>
                  {qrData && (
                    <div style={{ marginTop: "20px" }}>
                      <QRCodeCanvas id="qrCode" value={qrData} size={256} />
                      <div>
                        <button className="button is-primary" onClick={downloadQR}>
                          Download QR Code
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="field">
                    <label className="label">Name</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Name"
                        required
                      />
                    </div>
                    {errors.name && <p className="help is-danger">{errors.name}</p>}
                  </div>
                  <div className="field">
                    <label className="label">Father's Name</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="fatherName"
                        value={formData.fatherName}
                        onChange={handleChange}
                        placeholder="Father's Name"
                        required
                      />
                    </div>
                    {errors.fatherName && <p className="help is-danger">{errors.fatherName}</p>}
                  </div>
                  <div className="field">
                    <label className="label">Address</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        placeholder="Village/City"
                      />
                    </div>
                    {errors.address && <p className="help is-danger">{errors.address}</p>}
                  </div>
                  <div className="field">
                    <label className="label">District</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="district"
                        value={formData.district}
                        onChange={handleChange}
                        placeholder="District"
                      />
                    </div>
                    {errors.district && <p className="help is-danger">{errors.district}</p>}
                  </div>
                  <div className="field">
                    <label className="label">Family Head Number</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="phone1"
                        value={formData.phone1}
                        onChange={handleChange}
                        placeholder="Phone Number 1"
                        required
                      />
                    </div>
                    {errors.phone1 && <p className="help is-danger">{errors.phone1}</p>}
                  </div>
                  <div className="field">
                    <label className="label">Mobile Number 2</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="phone2"
                        value={formData.phone2}
                        onChange={handleChange}
                        placeholder="Phone Number 2"
                      />
                    </div>
                    {errors.phone2 && <p className="help is-danger">{errors.phone2}</p>}
                  </div>
                  <div className="field">
                    <label className="label">Mobile Number 3</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="phone3"
                        value={formData.phone3}
                        onChange={handleChange}
                        placeholder="Phone Number 3"
                      />
                    </div>
                    {errors.phone3 && <p className="help is-danger">{errors.phone3}</p>}
                  </div>
                  <div className="field">
                    <label className="label">Mobile Number 4</label>
                    <div className="control">
                      <input
                        type="text"
                        className="input"
                        name="phone4"
                        value={formData.phone4}
                        onChange={handleChange}
                        placeholder="Phone Number 4"
                      />
                    </div>
                    {errors.phone4 && <p className="help is-danger">{errors.phone4}</p>}
                  </div>
                  <div className="field">
                    <div className="control">
                      <label className="checkbox">
                        <input
                          type="checkbox"
                          checked={agreed}
                          onChange={(e) => setAgreed(e.target.checked)}
                          style={{ marginRight: "10px" }} // Add space between checkbox and label
                        />
                        I agree with the <Link to="/terms&conditions">terms & conditions</Link>
                      </label>
                    </div>
                  </div>
                  <div className="field">
                    <div className="control">
                      <button type="submit" className="button is-success">
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PublicForm;